import { render } from "./page-tag-categories.vue?vue&type=template&id=2379271a&scoped=true&lang=html"
import script from "./page-tag-categories.vue?vue&type=script&lang=js"
export * from "./page-tag-categories.vue?vue&type=script&lang=js"

import "./page-tag-categories.vue?vue&type=style&index=0&id=2379271a&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-2379271a"

export default script